import { render } from "./underwritters.configuration.vue?vue&type=template&id=7f074dbd"
import script from "./underwritters.configuration.vue?vue&type=script&lang=js"
export * from "./underwritters.configuration.vue?vue&type=script&lang=js"

import "./underwritters.configuration.vue?vue&type=style&index=0&id=7f074dbd&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__